<template>
  <v-snackbar @input="hideNotification()" :color="getNotificationType()" :value="showNotification" :top="true" :right="true" :multi-line="true">
    {{ getNotificationText() }}
    <v-btn text @click="hideNotification()" >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'notifications',
  computed: {
    ...mapGetters(['getNotification', 'hasNotifications', 'showNotification'])
  },
  watch: {
    showNotification () {
      if (!this.showNotification && this.hasNotifications) {
        this.$store.commit('setLastNotification')
        this.$nextTick(() => this.$store.commit('showNotification'))
      }
    }
  },
  methods: {
    hideNotification () {
      this.$store.commit('hideNotification')
    },
    getNotificationText () {
      try {
        return this.getNotification.text
      } catch (e) {
        return ''
      }
    },
    getNotificationType () {
      try {
        return this.getNotification.type
      } catch (e) {
        return ''
      }
    }
  }
}
</script>
